module.exports = __webpack_public_path__ + "img/titleText.38bf9cdc.png";